import styled from '@emotion/styled';
import React from 'react';

const LabelCardWrapper = styled.div`
    padding: 16px;
    flex: 1;
    display:flex;
    gap: 14px;
    align-items: center;
    border: 1px solid ${(props) => props.theme.colors.gray};
    border-radius: 16px;
`;

type LabelCardProps = {
  icon: React.ReactNode;
  title: string;
  value: string | number;
};

export default function LabelCard({ icon, title, value }: LabelCardProps) {
  return (
        <LabelCardWrapper>
            <div className='label-card-icon'>{icon}</div>
            <div className='label-card-info'>
                <div className='label-card-value'>{value}</div>
                <div className='label-card-title'>{title}</div>
            </div>
        </LabelCardWrapper>
  );
}